import { render, staticRenderFns } from "./ModalReviewPresentation.vue?vue&type=template&id=0c1c4091&"
import script from "./ModalReviewPresentation.vue?vue&type=script&lang=js&"
export * from "./ModalReviewPresentation.vue?vue&type=script&lang=js&"
import style0 from "./ModalReviewPresentation.vue?vue&type=style&index=0&id=0c1c4091&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports